
// subscriptionPlans.js
import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, CircularProgress } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CurrentPlans from "./CurrentPlan";
import PlansHistory from "./PlansHistory";
import UpgradePlans from "./UpgradePlans";
import { useSelector, useDispatch } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Slices/AuthSlice";

const SubscriptionAndPlans = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);
const { t } = useTranslation();
const location = useLocation();
const fromWebsite = new URLSearchParams(location.search).get("fromWebsite") === "true";
const upgradeToken = new URLSearchParams(location.search).get("upgrade_token");

useEffect(() => {
  if (location.state?.activeTab === "upgrade_plans") {
    setActiveTab(1); // second tab (index 1)
  }
}, [location.state]);

useEffect(() => {
  const savedTab = localStorage.getItem("activeTabIndex");

  if (location.state?.activeTab === "upgrade_plans") {
    setActiveTab(1);
  } else if (savedTab) {
    setActiveTab(Number(savedTab));
    localStorage.removeItem("activeTabIndex"); // clean up after applying
  }
}, [location.state]);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = upgradeToken || (token ? decryptToken(token) : null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await fetch(`${BASE_URL}/payments/company-admin/plan-details`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });

        if (response.status === 401) {
          // No valid session (upgrade link already used/expired, or stale/missing
          // token) — nothing to show here, send to login instead of a broken page.
          dispatch(logout());
          navigate("/", { replace: true });
          return;
        }

        const result = await response.json();
        setPlanData(result.data);
      } catch (err) {
        console.error("Failed to fetch plan details", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlan();
  }, [decryptedToken]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, backgroundColor: "white", mt: 1, mx: 1, borderRadius: 2 }}>
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 600,
          fontSize: "22px",
          color: "#003149",
          textAlign: "left",
        }}
      >
  {t("subscriptionPage.title")}
      </CustomText>

      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mt: 2, mb: 2, minHeight: "32px" }}
      >
        <Tab label={t("subscriptionPage.current_plan")} sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }} />
        <Tab label={t("subscriptionPage.upgrade_plans")} sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }} />
        <Tab label={t("subscriptionPage.plans_history")} sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }} />
      </Tabs>

      {activeTab === 0 && <CurrentPlans planData={planData} />}
      {activeTab === 1 && 

  <UpgradePlans
    currentPlanId={planData?.current_plan?.plan_id}
    upgradeRequired={planData?.upgrade_info?.upgrade_required}
    subscriptionStatus={planData?.subscription_status?.status}
     detailedStatus={planData?.subscription_status?.detailed_status}
       currentWorkerCount={planData?.pricing_info?.current_pricing_breakdown?.worker_count}

  />
 }
      {activeTab === 2 && <PlansHistory />}
    </Box>
  );
};

export default SubscriptionAndPlans;








